/**
 * 全ページに読み込ませる共通処理はここに記述
 * views/layouts/application.htmlでロードしている
 */
import 'stylesheets/application';
import FlashReport from 'modules/FlashReport';
import GlobalLazyLoad from 'modules/GlobalLazyLoad';
import WindowConfirm from 'modules/WindowConfirm';
import PreventDoubleClick from 'modules/PreventDoubleClick';
import PreventDoubleSubmit from 'modules/PreventDoubleSubmit';
import Toastr from 'modules/Toastr';

window.toastr = require('toastr');

window.toastr.options.timeOut = 2000;

// EventBus
if (!window.EventBus) {
  window.EventBus = new Vue();
}

// LazyLoad
new GlobalLazyLoad();

// 速報
new FlashReport();

// window.$confirmを定義
new WindowConfirm();

new PreventDoubleClick();
new PreventDoubleSubmit();

// トースト
new Toastr();
